import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const STORAGE_KEY = 'liftlogic:selectedTenantId';

/**
 * Hook reutilizable para páginas del perfil liftlogic que necesitan operar
 * sobre un tenant seleccionado. Persiste la selección en sessionStorage
 * para que navegar entre páginas no pierda el contexto.
 */
const useTenantSelector = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTenantId, setSelectedTenantIdState] = useState(() => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? Number(raw) : null;
  });

  const setSelectedTenantId = useCallback((id) => {
    setSelectedTenantIdState(id);
    if (id == null) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, String(id));
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${API_PATH}/tenants`, {
          headers: { Authorization: getAccessTokenApi() },
        });
        if (cancelled) return;
        setTenants(res.data ?? []);
        if (!selectedTenantId && res.data?.length) {
          setSelectedTenantId(res.data[0].id);
        }
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { tenants, selectedTenantId, setSelectedTenantId, loading, error };
};

export default useTenantSelector;
